import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ProductCard.css';

const ProductCard = ({ product }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/products/${product.id}`);
  };

  // Get product type label for display
  const getTypeLabel = (type) => {
    const labels = {
      'ebook': 'E-Book',
      'audiobook': 'Audiobook',
      'game': 'Game',
      'podcast': 'Podcast'
    };
    return labels[type] || type;
  };

  return (
    <div className="product-card" onClick={handleClick}>
      <div className="product-card-image">
        {product.thumbnail_url ? (
          <img src={product.thumbnail_url} alt={product.title} />
        ) : (
          <div className="product-card-placeholder">
            <span>{getTypeLabel(product.product_type)}</span>
          </div>
        )}
      </div>
      <div className="product-card-content">
        <span className="product-card-type">{getTypeLabel(product.product_type)}</span>
        <h3 className="product-card-title">{product.title}</h3>
        <p className="product-card-summary">
          {product.summary 
            ? (product.summary.length > 100 
                ? product.summary.substring(0, 100) + '...' 
                : product.summary)
            : 'No description available.'}
        </p>
        <div className="product-card-footer">
          <span className="product-card-price">
            {product.price > 0 ? `$${product.price}` : 'Free'}
          </span>
          <button className="product-card-btn">View Details</button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
